import type { TableQualityApiResponse } from '@/entities/quality/api/getTableQualityData';
import type { QualityLevel } from '@/entities/quality/domain';

export type TableQualityTableData = {
  key: string;
  fqn: string;
  tableName: string;
  dataZone: string;
  cumulativeRowCount: number;
  testType: string;
  qualityStatus: {
    goodRows: number;
    goodRatio: number;
    poorRows: number;
    poorRatio: number;
    unknownRows: number;
    unknownRatio: number;
  };
  incrementalRows: number;
  qualityEvaluationDate: string;
  qualityLevel: QualityLevel;
};

export const transformTableApiDataToTableData = (apiData: TableQualityApiResponse): TableQualityTableData => {
  return {
    key: `${apiData.tableId}-${apiData.statDate}-${apiData.collectedAt}`,
    fqn: apiData.fqn,
    tableName: apiData.tableName,
    dataZone: apiData.dataZone,
    cumulativeRowCount: apiData.totalRows,
    testType: '결측치',
    qualityStatus: {
      goodRows: apiData.goodRows,
      goodRatio: apiData.goodRatio,
      poorRows: apiData.poorRows,
      poorRatio: apiData.poorRatio,
      unknownRows: apiData.unknownRows,
      unknownRatio: apiData.unknownRatio,
    },
    incrementalRows: apiData.incrementalRows,
    qualityLevel: apiData.qualityLevel,
    qualityEvaluationDate: apiData.collectedAt,
  };
};
